import en from "./en";
import fr from "./fr";



const resources = {
  en: {
    translation: en
  },
  fr: {
    translation: fr
  },
};

export default resources;
